import { Box, Typography } from "@mui/material"

type Reason = {
    title: string
    description?: string
}

interface Props {
    title: string
    description?: string
    causesTitle?: string
    reasons: Reason[]
}

const ProxyAlert = ({ title, description, causesTitle, reasons }: Props) => {
    return (
        <>
            <Box
                sx={{
                    mt: 1,
                    p: 4,
                    border: (theme) => `1px solid ${theme.palette.error.main}`,
                    borderRadius: 1,
                }}
            >
                <Typography variant="h5" sx={{ pb: 1 }} color={"error"}>
                    {title}
                </Typography>
                {description ? (
                    <Typography variant="body1" color={"error"} sx={{ pb: 2 }}>
                        {description}
                    </Typography>
                ) : null}
                {causesTitle ? (
                    <Typography variant="subtitle1" color={"error"} sx={{ pb: 1 }}>
                        {causesTitle}
                    </Typography>
                ) : null}
                <Box component="ul" sx={{ m: 0, pl: 3, color: "error.main" }}>
                    {reasons.map((reason, index) => (
                        <Box component="li" key={`${reason.title}-${index}`} sx={{ mb: 1 }}>
                            <Typography variant="body1" color={"error"}>
                                {reason.title}
                            </Typography>
                            {reason.description ? (
                                <Box component="ul" sx={{ mt: 0.5, mb: 0, pl: 3 }}>
                                    <Box component="li">
                                        <Typography variant="body2" color={"error"}>
                                            {reason.description}
                                        </Typography>
                                    </Box>
                                </Box>
                            ) : null}
                        </Box>
                    ))}
                </Box>
            </Box>
        </>
    )
}

export default ProxyAlert
